import React, { useEffect, useState } from "react";
import { useTabs } from "../../hooks/lib/useTabs";
import UndergraduateIntroBanner from "../undergraduate/UndergraduateIntroBanner";
import { useLoader } from "../../context/LoaderContext";
import { fetchSastDetailsBanner } from "../../api/UndergraduateProgramsApi";
import { dynamicFailed } from "../../hooks/custom/useToast";
import {
  IAcademicsMppDetailsBannerData,
  ISastDetailsBannerData,
} from "../../exports/interfaces";
import GraduateIntroBanner from "../graduate/GraduateIntroBanner";
import { fetchAcademicsMppDetailsBanner } from "../../api/GraduateProgramsApi";
import { useMobile } from "../../hooks/custom/useMobile";
import useTab from "../../hooks/custom/useTab";

export const PopularCourses = () => {
  useTabs();

  const mobile = useMobile();
  const tab = useTab();

  const { setLoading } = useLoader();

  const [sastDetailsBanner, setSastDetailsBanner] = useState<
    ISastDetailsBannerData[]
  >([]);
  const [academicsMppDetailsBanner, setAcademicsMppDetailsBanner] = useState<
    IAcademicsMppDetailsBannerData[]
  >([]);

  useEffect(() => {
    setLoading(true);

    Promise.all([fetchSastDetailsBanner(), fetchAcademicsMppDetailsBanner()])
      .then(([sastDetailsBannerData, academicsMppDetailsBannerData]) => {
        setSastDetailsBanner(sastDetailsBannerData);
        setAcademicsMppDetailsBanner(academicsMppDetailsBannerData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);

  return (
    <section className="td_gray_bg_3">
      <div className="td_height_50 td_height_lg_40" />

      <div className="container">
        {/* header */}
        <div
          className="td_section_heading td_style_1 text-center wow fadeInUp"
          data-wow-duration="1s"
          data-wow-delay="0.15s"
        >
          {/* <p
            className="td_section_subtitle_up td_fs_18 td_semibold td_spacing_1 td_mb_10 text-uppercase td_accent_color"
            style={{ textAlign: "unset" }}
          >
            Popular Programs
          </p> */}
          <h2 className="td_section_title td_fs_48 mb-0">Academics</h2>
        </div>
        <div className="td_height_30 td_height_lg_30" />

        {/* tabs */}
        <div className="td_tabs">
          <ul
            className="td_tab_links td_style_1 td_mp_0 td_fs_20 td_medium td_heading_color wow fadeInUp"
            data-wow-duration="1s"
            data-wow-delay="0.2s"
          >
            <li
              className="active"
              style={{ width: mobile || tab ? "100%" : "unset" }}
            >
              <a
                href="#tab_1"
                style={{
                  width: mobile || tab ? "100%" : "unset",
                  display: mobile || tab ? "flex" : "block",
                  justifyContent: "center",
                }}
              >
                School of Arts, Sciences & Technology (SAST)
              </a>
            </li>
            <li style={{ width: mobile || tab ? "100%" : "unset" }}>
              <a
                href="#tab_2"
                style={{
                  width: "100%",
                  display: mobile || tab ? "flex" : "block",
                  justifyContent: "center",
                }}
              >
                School of Public Policy (SPP)
              </a>
            </li>
          </ul>

          <div className="td_tab_body">
            <div className="td_tab active" id="tab_1">
              <UndergraduateIntroBanner sastDetailsBanner={sastDetailsBanner} />
            </div>

            <div className="td_tab" id="tab_2">
              <GraduateIntroBanner
                academicsMppDetailsBanner={academicsMppDetailsBanner}
              />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="td_height_50 td_height_lg_50" /> */}
    </section>
  );
};
